module.exports = __webpack_public_path__ + "static/img/partner12.ef5c2ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/partner12.png
// module id = Afzu
// module chunks = 202